let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7vfNh")).then(() => parcelRequire('6vucW'));